import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Translation} from 'react-i18next';

import {connect} from 'react-redux';
import {patchUser} from 'redux/settings/actions';

import {Field, reduxForm} from "redux-form";

import YourHeylinkSite from 'components/dashboard/earn-content/adsense/YourHeylinkSite';
import Button from 'components/elements/buttons/Button';
import {Form} from 'semantic-ui-react';
import TextField from 'components/redux-form-adapters/TextField';
import CommonMessage from 'components/common/CommonMessage';
import AdsenseInfoIcon from 'components/dashboard/earn-content/adsense/AdsenseInfoIcon';

import {PUBLIC_SITE_URL} from 'utils/restapi';

import validate from './validate';

import './ConnectAdsenseForm.css';


function ConnectAdsenseForm(props) {
  const {
    handleSubmit,
    patchUser,
    valid,
    reset,
    patchUserSuccess,
    patchUserError,
    setIdSaved,
  } = props;

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (patchUserSuccess && patchUserSuccess.adsense_publisher_id) {
      setIdSaved(true);
    }
  }, [patchUserSuccess]);

  const _handleSubmit = values => {
    const form = new FormData();
    form.append('adsense_publisher_id', values.adsense_publisher_id);
    patchUser(form);
    reset();
  };

  const connectUrl = `https://www.google.com/adsense/new/sites?url=${PUBLIC_SITE_URL.replace('http://', '')}/&source=heylink.me`;

  return (
    <Translation>
      {(t) => (
        <div className="connect-adsense-form__component">
          <a
            className="connect-adsense"
            href={connectUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button onClick={() => setShowForm(true)}>{t("Connect AdSense")}</Button>
          </a>


          {showForm &&
          <div className="form-wrapper">
            <YourHeylinkSite/>

            <div className="form-label">
              <div className="text">
                {t("Paste Publisher ID that you see in your AdSense " +
                  "(Account -> Settings -> Account Information)")}
              </div>
              <AdsenseInfoIcon/>
            </div>

            <Form
              onSubmit={handleSubmit(_handleSubmit)}
              error={!valid}
            >
              <Field
                component={TextField}
                name="adsense_publisher_id"
                type="text"
                placeholder="pub-0123456789XXXXXX"
                required
              />
              <Button
                submit
                disabled={!valid}
              >
                {t("Submit")}
              </Button>
            </Form>

            {patchUserError &&
            <CommonMessage
              error
              errors={patchUserError}
            />
            }
          </div>
          }
        </div>
      )}
    </Translation>
  );
}

ConnectAdsenseForm.propTypes = {
  patchUser: PropTypes.func.isRequired,
  setIdSaved: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  patchUserSuccess: PropTypes.object,
  patchUserError: PropTypes.object,
};

ConnectAdsenseForm.propTypes = {
  patchUserSuccess: null,
  patchUserError: null,
};

const mapStateToProps = state => (
  {
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(reduxForm({
  form: 'ConnectAdsenseForm',
  validate,
})(ConnectAdsenseForm));
